import React from 'react';
import {Row, Col, Card} from 'react-materialize';
import ergonomic from "../../images/ergonomic.png";
import excessive_physical_effort from "../../images/excessive_physical_effort.png";
import psychossocial from "../../images/psychosocial.png";
import excessive_workday from "../../images/excessive_workday.png";
import {FormattedMessage} from "react-intl";

const RiscoErgonomico = () => (

    <Card>
        {/*RISCOS ERGONÔMICOS*/}

        <Row>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={ergonomic} className={"img"}/> </div>

            </Col>

            <Col s={10} m={10}>
                <h5><p><b><FormattedMessage id={"ergonomic"} defaultMessage={"Risco ergonômico"}/></b></p></h5>
            </Col>

        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={excessive_physical_effort} className={"img"}/>
                </div>
            </Col>

            <Col s={10} m={10}>
                <div align="justify">
                    <p><b><FormattedMessage id={"excessive"} defaultMessage={"Excesso de esforço físico"}/></b></p>

                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"excessive.text"} defaultMessage={"Os problemas musculoesqueléticos estão relacionados ao carregamento de excesso de peso, má postura durante o manuseio dos animais no processo de colheita, quedas e escorregões;"}/></p>
                        <p><FormattedMessage id={"excessive.text2"} defaultMessage={"Enchimento manual de tanques vivos com água;"}/></p>
                        <p><FormattedMessage id={"excessive.text3"} defaultMessage={"Descarregar peixe de tanques ou redes;"}/></p>
                        <p><FormattedMessage id={"excessive.text4"} defaultMessage={"Rede e elevação de cargas de pescado;"}/></p>
                        <p><FormattedMessage id={"excessive.text5"} defaultMessage={"Rede, pesagem e transferência de pescado;"}/></p>
                        <p><FormattedMessage id={"excessive.text6"} defaultMessage={"Movimentos repetitivos;"}/></p>
                        <p><FormattedMessage id={"excessive.text7"} defaultMessage={"Posição prolongada;"}/></p>
                        <p><FormattedMessage id={"excessive.text8"} defaultMessage={"Carregar redes de pesca cheias;"}/></p>
                        <p><FormattedMessage id={"excessive.text9"} defaultMessage={"Carregar sacas de ração sem auxílio mecânico."}/></p>
                        <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"excessive.text10"} defaultMessage={"O recuo da água pode causar lesões por esforço ou derrubar um trabalhador, resultando em ferimentos graves;"}/></p>
                        <p><FormattedMessage id={"excessive.text11"} defaultMessage={"Lesão por esforço repetitivo (LER);"}/> </p>
                        <p><FormattedMessage id={"excessive.text12"} defaultMessage={"Dores e doenças musculares;"}/></p>
                        <p><FormattedMessage id={"excessive.text13"} defaultMessage={"Formigamento;"}/></p>
                        <p><FormattedMessage id={"excessive.text14"} defaultMessage={"Fraqueza;"}/></p>
                        <p><FormattedMessage id={"excessive.text15"} defaultMessage={"Rigidez;"}/></p>
                        <p><FormattedMessage id={"excessive.text16"} defaultMessage={"Fadiga;"}/></p>
                        <p><FormattedMessage id={"excessive.text17"} defaultMessage={"Dores musculares nos membros e coluna vertebral;"}/></p>
                        <p><FormattedMessage id={"excessive.text18"} defaultMessage={"Desgastes das estruturas musculoesqueléticas."}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                            <li><b><FormattedMessage id={"elimination"} defaultMessage={"Eliminação ou substituição:"} /></b></li>
                        <p><FormattedMessage id={"excessive.text19"} defaultMessage={"Utilizar equipamentos mecânicos para eliminar ou diminuir o esforço físico;"}/></p>
                        <p><FormattedMessage id={"excessive.text20"} defaultMessage={"Utilizar polia, trilho ou guindaste para levantar redes na despesca ou transportar cargas."}/></p>
                            <li><b><FormattedMessage id={"engineering"} defaultMessage={"Controles de engenharia:"}/></b></li>
                        <p><FormattedMessage id={"excessive.text21"} defaultMessage={"Diminuir a altura dos tanques para melhorar posturas de elevação."}/></p>
                            <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                        <p><FormattedMessage id={"excessive.text22"} defaultMessage={"Manter boa postura e modificar frequentemente;"}/></p>
                        <p><FormattedMessage id={"excessive.text23"} defaultMessage={"Reduzir o peso de cargas elevadas (como redes de imersão cheias de peixes);"}/></p>
                            <p><FormattedMessage id={"excessive.text24"} defaultMessage={"Fazer pausas."}/></p></ul></ul>
                </div>
            </Col>
        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={psychossocial} className={"img"}/>
                </div>
            </Col>

            <Col s={10} m={10}>
                <div align="justify">
                    <p><b><FormattedMessage id={"psychosocial"} defaultMessage={"Psicossociais"}/></b></p>

                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                        <p><FormattedMessage id={"psychosocial.text"} defaultMessage={"Os riscos psicossociais são causados, principalmente, quando os trabalhadores são expostos a situação de estresse e quando ficam muito tempo longe da família e sem descanso."}/></p>
                        <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                        <p><FormattedMessage id={"psychosocial.text2"} defaultMessage={"Ansiedade; Depressão; Estresse relacionado ao trabalho."}/></p>
                        <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                        <ul className={"browser-default"}>
                            <li><b><FormattedMessage id={"administration"} defaultMessage={"Administrativos e EPIs:"}/></b></li>
                            <p><FormattedMessage id={"psychosocial.text3"} defaultMessage={"Palestras e seminários voltados a qualidade de vida do trabalhador."}/></p> </ul></ul>
                </div>
            </Col>

        </Row>

        <Row className={"valign-wrapper"}>
            <Col s={2} m={2}>
                <div align="center">
                    <img src={excessive_workday} className={"img"}/>
                </div>
            </Col>

            <Col s={10} m={10}>
                <p><b><FormattedMessage id={"work"} defaultMessage={"Jornada de trabalho excessiva"}/></b></p>
                <ul className={"browser-default"}>
                    <li><b><FormattedMessage id={"source"} defaultMessage={"Causa/Fonte/Perigo"}/></b></li>
                    <p><FormattedMessage id={"work.text"} defaultMessage={"Jornadas de trabalho maiores que 8 horas diárias ou maiores que 44 horas semanais;"}/></p>
                    <p><FormattedMessage id={"work.text2"} defaultMessage={"Pouco tempo de descanso ou intervalos."}/></p>
                    <li><b> <FormattedMessage id={"risks"} defaultMessage={"Risco/Danos à Saúde:"}/></b></li>
                    <p><FormattedMessage id={"work.text3"} defaultMessage={"Cansaço e fadiga; Diminuição da produtividade; Descuido e desatenção;"}/></p>
                    <p><FormattedMessage id={"work.text4"} defaultMessage={"Dores musculares."}/></p>
                    <li><b><FormattedMessage id={"control"} defaultMessage={"Controle e prevenção:"}/></b></li>
                    <ul className={"browser-default"}>
                        <li><b><FormattedMessage id={"elimination"} defaultMessage={"Eliminação ou substituição:"} /></b></li>
                        <p><FormattedMessage id={"work.text5"} defaultMessage={"Manter a jornada de trabalho adequada."}/></p> </ul></ul>
            </Col>

        </Row>
    </Card>
);

export default RiscoErgonomico;